/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { getHygraphCosmosPageData } from "@cosmos/hygraph-data";
import {
	CosmosPageLegalContentMetadataQuery,
	CosmosPageLegalContentSlugSingleQuery,
	Locale,
} from "@cosmos/hygraph-schema";
import { getHygraphLocale, getSlugParam } from "@cosmos/next-common";
import { isError } from "@epic-mw/error-types";
import { Metadata } from "next";

import { CosmosPageMetadata } from "../common/page.types";

const getPageMetadata = async (
	locale: string = Locale.En,
	slug: string,
	previewParam?: string | string[],
): Promise<CosmosPageLegalContentMetadataQuery> => {
	if (!slug) {
		throw new Error("Missing slug");
	}
	const preview = previewParam && typeof previewParam === "string" ? previewParam : undefined;

	const pageData = await getHygraphCosmosPageData(
		"CosmosPageLegalContentMetadata",
		{
			locale: [locale, Locale.En] as Locale[],
			slug,
		},
		preview,
	);

	return pageData;
};

export async function cosmosPageLegalContentMetadata({
	slug: rootSlug = "",
	params,
	searchParams,
	hygraphLocales,
	getAppMetadata,
}: CosmosPageMetadata): Promise<Metadata> {
	const slugParam = getSlugParam(params);
	const slug = `${rootSlug}${slugParam}`;
	const locale = params.lang;
	let pageData: CosmosPageLegalContentMetadataQuery = {};
	try {
		pageData = await getPageMetadata(getHygraphLocale(hygraphLocales, locale), slug, searchParams.preview);
	} catch (e) {
		console.error("Failed to get cosmosPageLegalContentMetadata()", { error: isError(e) && e.message });
	}
	const metaTags = pageData.cosmosPageLegalContent?.metaTags || {};

	return getAppMetadata(metaTags, slug, locale);
}

const getSlugsDataSingle = async (
	locale: string = Locale.En,
	slug: string,
	previewParam?: string | string[],
): Promise<CosmosPageLegalContentSlugSingleQuery> => {
	if (!slug) {
		throw new Error("Missing slug");
	}
	const preview = previewParam && typeof previewParam === "string" ? previewParam : undefined;

	const pageData = await getHygraphCosmosPageData(
		"CosmosPageLegalContentSlugSingle",
		{
			locale: [locale] as Locale[],
			slug,
		},
		preview,
	);

	return pageData;
};

export async function checkPageLegalContentSlug(
	slug = "",
	locale: string,
	preview: string | string[] | undefined,
	hygraphLocales: string[],
): Promise<boolean> {
	try {
		const pageData = await getSlugsDataSingle(getHygraphLocale(hygraphLocales, locale), slug, preview);
		return !!pageData?.cosmosPageLegalContent?.id && pageData?.cosmosPageLegalContent?.slug === slug;
	} catch (e) {
		console.error("Failed to get getSlugsDataSingle()", { error: isError(e) && e.message });
	}
	return false;
}
